import React, { InputHTMLAttributes, RefObject } from 'react';
import classNames from 'classnames';

import styles from './TextInput.module.scss';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  startAdornment?: () => JSX.Element;
  endAdornment?: () => JSX.Element;
  iconPlacement?: 'start' | 'end';
  inputClassName?: string;
  startAdornmentClassname?: string;
  endAdornmentClassname?: string;
  error?: string;
  inputRef?: RefObject<HTMLInputElement>;
}

const TextInput = ({
  iconPlacement,
  inputClassName,
  startAdornmentClassname,
  endAdornmentClassname,
  className,
  error,
  inputRef,
  startAdornment,
  endAdornment,
  ...restProps
}: InputProps) => (
  <div className={classNames(styles.input_root, className)}>
    <input ref={inputRef} className={classNames(styles.input, inputClassName)} {...restProps} />
    {startAdornment && (
      <div className={classNames(styles.adornment_container_start, startAdornmentClassname)}>{startAdornment()}</div>
    )}
    {endAdornment && (
      <div className={classNames(styles.adornment_container_end, endAdornmentClassname)}>{endAdornment()}</div>
    )}
  </div>
);

export default TextInput;
